
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToTop = () => {
  const { pathname } = useLocation();
  const [isPageReady, setIsPageReady] = useState(false);
  
  useEffect(() => {
    // Reset page ready state on route change
    setIsPageReady(false);
    
    // Wait for page to be fully loaded and mounted
    const handlePageReady = () => {
      // Wait for DOM content to be loaded
      if (document.readyState === 'complete') {
        // Additional delay to ensure React components are mounted and rendered
        setTimeout(() => {
          setIsPageReady(true);
        }, 100);
      } else {
        // Wait for the page to finish loading
        window.addEventListener('load', () => {
          setTimeout(() => {
            setIsPageReady(true);
          }, 100);
        }, { once: true });
      }
    };

    handlePageReady();
  }, [pathname]);

  useEffect(() => {
    if (isPageReady) {
      // Use requestAnimationFrame to ensure DOM is painted
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }
  }, [isPageReady]);
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
